const LOGIN_ROUTE = { name: 'login' }
const HOME_ROUTE = { name: 'browse' }
const ACCOUNT_ROUTE = { name: 'account' }
const UNAUTHORIZED_ROUTE = { name: 'inactive' }
const PLAYLIST_GROUP_ROUTE = { name: 'playlist-group-view' }

export { ACCOUNT_ROUTE, LOGIN_ROUTE, HOME_ROUTE, UNAUTHORIZED_ROUTE, PLAYLIST_GROUP_ROUTE }

export const routerState = {
  REDIRECTED: 'redirected',
  CANCELED: 'canceled',
  ALLOWED: 'allowed'
}

export function extractRedirect(route, name) {
  if (!route.meta.redirects) {
    return null
  }
  return { ...route.meta.redirects[name], params: { ...route.params }, query: { ...route.query } }
}

export function extractExcludedPlatforms(route) {
  if (!route.meta.excludedPlatforms) {
    return []
  }

  return route.meta.excludedPlatforms
}

export function extractAllowedPlatforms(route) {
  return route.meta.allowedPlatforms
}
